module.exports = __webpack_public_path__ + "school/img/baoming.22e1a15b.jpg";